// Check if the editor is empty

export const isEditorEmpty = (editor, children) =>
  editor.children.length === 1 &&
  editor.children[0]?.children?.length === 1 &&
  children?.[0]?.props?.text?.text === '';
